import { Routes, Route } from "react-router-dom";
import DefaultTableSettings from "./DefaultTableSettings";

const index = () => {
	return (
		<Routes>
			<Route index element={<DefaultTableSettings />} />
		</Routes>
	);
};

export default index;
